export default __webpack_public_path__ + "static/media/link.3467f06c.svg";